<template>
  <div class="exam-detail">
    <div class="message">
      <div class="top">
        <!-- <p style="font-size: 20px; cursor: pointer" @click="goBack">返回</p> -->
        <div class="topBack">
          <img
            @click="goBack"
            src="../assets/image/order_back.png"
            alt=""
            class="backImg"
          />
          <!-- 返回 -->
        </div>
        <div>
          <img
            src="../assets/image/detailImg.png"
            alt=""
            style="width: 200px; margin-top: 20px"
          />
        </div>
        <!-- <p>考试预约凭证</p>
        <p class="eng">Examination reservation</p>
        <p class="eng">voucher</p> -->
      </div>
      <div class="bottom">
        <p class="title">{{ reservationName }}</p>
        <div class="item">
          <div>座位号</div>
          <div>{{ $route.query.seatNumber }}</div>
        </div>
        <div class="item">
          <div>姓名</div>
          <div>{{ stuName }}</div>
        </div>
        <div class="item">
          <div>学号</div>
          <div>{{ stuNumber }}</div>
        </div>
        <div class="item">
          <div>考场</div>
          <div>{{ reservationItemName }}</div>
        </div>
        <div class="item">
          <div class="time">考试时间</div>
          <div>
            <p>{{ dateFormat(reservationItemStartTime) }}</p>
            <p>{{ dateFormat(reservationItemEndTime) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-btn">
      <el-button
        type="primary"
        v-if="stuCancel"
        size="small"
        style="
          width: 90%;
          position: absolute;
          bottom: 40px;
          left: 20px;
          font-size: 18px;
        "
        @click="cancelExam"
      >
        取消预约
      </el-button>
    </div>
  </div>
</template>

<script>
import axios from "@/libs/api.request";
import { formatSS } from "@/utils/datetime";
export default {
  name: "OrderPage",
  data() {
    return {
      reservationName: "",
      reservationItemName: "",
      reservationItemStartTime: "",
      reservationItemEndTime: "",
      stuName: "",
      stuNumber: "",
      stuCancel: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/order",
        query: {
          uid: this.$route.query.uid,
          name: this.$route.query.name,
          school: this.$route.query.school,
          num: this.$route.query.num,
          reservationId: this.$route.query.reservationId,
          isActive: this.$route.query.isActive,
          shareCode: this.$route.query.shareCode,
          // reservationStuId: row.reservationStuId,
          token: this.$route.query.token,
          back: 1,
          // seatNumber: row.seatNumber,
        },
      });
    },
    dateFormat(row) {
      return formatSS(row);
    },
    getMessage() {
      let data = {};
      data.stuId = this.$route.query.uid;
      data.reservationStuId = this.$route.query.reservationStuId;
      data.token = this.$route.query.token;
      data.uid = this.$route.query.uid;
      axios
        .request({
          method: "post",
          url: `${process.env.VUE_APP_BASE_URL}/exam/reservationStu/queryInfo`,
          data: data,
        })

        .then((res) => {
          let ret = res.data;
          if (ret.code == 200) {
            this.reservationItemName = ret.data.reservationItemName;
            this.reservationItemStartTime = ret.data.reservationItemStartTime;
            this.reservationItemEndTime = ret.data.reservationItemEndTime;
            this.reservationName = ret.data.reservationName;
            this.stuName = ret.data.stuName;
            this.stuNumber = ret.data.stuNumber;
            this.stuCancel = ret.data.stuCancel;
          } else if (ret.code == 201) {
            this.$message.warning("您已预约！");
          }
        });
    },
    // cancelExam() {
    //   this.$confirm("请确认是否取消预约?", "提示", {
    //     cancelButtonText: "取消",
    //     confirmButtonText: "确定",
    //     dangerouslyUseHTMLString: true,
    //     type: "warning",
    //     customClass: "custom-confirm-box",
    //   })
    //     .then(() => {})
    //     .catch(() => {});
    // },
    cancelExam() {
      // 动态创建 style 标签
      const style = document.createElement("style");
      style.innerHTML = `
      .custom-confirm-box {
        width: 300px !important;
      }
    `;
      document.head.appendChild(style);

      this.$confirm("请确认是否取消预约?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
        type: "warning",
        customClass: "custom-confirm-box",
      })
        .then(() => {
          let data = {};
          data.reservationStuId = this.$route.query.reservationStuId;
          data.token = this.$route.query.token;
          data.uid = this.$route.query.uid;
          axios
            .request({
              method: "post",
              url: `${process.env.VUE_APP_BASE_URL}/exam/reservationStu/stu/cancel`,
              data: data,
            })
            .then((res) => {
              let ret = res.data;
              if (ret.code == 200) {
                this.$message.success("取消成功！");
                this.goBack();
              } else if (ret.code == 201) {
                this.$message.warning(ret.msg);
              }
            });
        })
        .catch(() => {})
        .finally(() => {
          // 销毁时移除 style 标签
          // document.head.removeChild(style);
        });
    },
  },
  mounted() {
    this.getMessage();
  },
};
</script>

<style lang="less" scoped>
.exam-detail {
  //   background: green;
  background: white;
  height: 100vh;
  //   height: calc(100% - 60px);
  overflow-y: auto;
  width: 100%;
  max-width: 400px;
  //   padding: 15px;

  .message {
    background: url("../assets/image/detail_back1.png") no-repeat;
    background-size: cover; /* 图片覆盖整个div */
    background-position: center; /* 图片居中显示 */
    background-repeat: no-repeat; /* 不重复显示 */
    height: 470px;
    .top {
      color: white;
      padding: 1px 0 0 20px;
      font-size: 24px;
      .topBack {
        margin-top: 15px;
        display: flex;
        font-size: 18px;
        .backImg {
          width: 25px;
          height: 25px;
          cursor: pointer;
        }
      }
      .eng {
        font-size: 16px;
      }
    }
    .bottom {
      background: url("../assets/image/detail_back.png") no-repeat;
      background-size: cover; /* 图片覆盖整个div */
      background-position: center; /* 图片居中显示 */
      background-repeat: no-repeat; /* 不重复显示 */
      height: 300px;
      margin: 0 20px;
      .title {
        display: flex;
        justify-content: center;
        font-size: 18px;
        padding-top: 9px;
        color: #1684fc;
      }
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 20px;
      }
    }
  }
  .bottom-btn {
    height: calc(100vh - 470px);
    background: #f7f8f9;
    position: relative; /* 作为绝对定位的参考上下文 */
    width: 100%; /* 占满父级宽度 */
  }
  /deep/ .el-message-box.custom-confirm-box {
    width: 300px !important;
  }
}
</style>